import { WidgetsIdsRequestMain } from '@/widgets/ids-request';

export const PagesIdsRequestMain = () => <WidgetsIdsRequestMain />;
